export default class User {
  constructor (data = {}) {
    Object.keys(data).map(key => {
      this[key] = data[key];
    });
  }
  static fromJson (json) {
    return new User(json);
  }
}
